module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/appModalCrumbView.html -->\n<span class="mdc-tab__content">\n	<h5 class="mdc-typography--headline5 header__title mdc-tab__text-label nx-title">'+
((__t=( label ))==null?'':__t)+
'</h5>\n</span>\n<span class="mdc-tab-indicator '+
((__t=( active || !index ? 'mdc-tab-indicator--active' : '' ))==null?'':__t)+
'">\n	<span class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>\n</span>\n<span class="mdc-tab__ripple"></span>';
}
return __p;
};
